import * as React from 'react';

import {Body} from '../typography/body';
import type {Props as BodyProps} from '../typography/body';

import styles from './error-message.module.css';

type Props = {
    as: string;
    children: React.ReactNode;
} & BodyProps;

ErrorMessage.defaultProps = {
    as: 'div',
};

export function ErrorMessage(props: Props) {
    const {as: Tag, children, ...bodyProps} = props;

    return (
        // @ts-expect-error
        <Tag className={styles.error}>
            <Body {...bodyProps}>{children}</Body>
        </Tag>
    );
}
